import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { LoadingIndicator } from '@leagueplatform/web-common-components';
import { useAnalyticsIdentify } from '@leagueplatform/web-common';
import { useAuth } from '@leagueplatform/auth-utils';
import { ROUTE_PATHS, TENANT_ID } from 'common/constants/constants';

export const AuthorizedRoutes = () => {
  const { isAuthenticated, error } = useAuth();
  useAnalyticsIdentify({ employer_group_id: '', tenant_id: TENANT_ID });

  // Capture redirect path
  const { pathname, search } = useLocation();

  // isAuthenticated is initially undefined
  if (error) return <Navigate to={ROUTE_PATHS.SIGN_OUT} />;
  if (isAuthenticated === undefined) return <LoadingIndicator />;
  if (isAuthenticated === false)
    return (
      <Navigate
        to={{ pathname: ROUTE_PATHS.SIGN_IN }}
        state={{ redirectPath: pathname, search }}
      />
    );
  return <Outlet />;
};
